<template>
  <div class="tourHotelPlaceModal_group">
    <tk-link
      v-show="!!path.length"
      class="tourHotelPlaceModal_prevBtn"
      @click="onBack"
    >
      <span class="arrow leftArrow">戻る</span>
    </tk-link>
    <h3
      class="tourHotelPlaceModal_subTitle tourHotelPlaceModal_subTitle-center"
    >
      {{ currentItem.title }}
    </h3>
    <ul class="tourHotelPlaceModal_radioList">
      <tk-radio
        v-for="item in currentItem.items"
        :key="item.value"
        v-model="selected"
        :label="item.label"
        :value="item.value"
        @click="onClicked(item)"
      />
    </ul>
  </div>
</template>

<script>
import TkLink from '../TkLink/TkLink'
import TkRadio from '../TkRadio/TkRadio'

export default {
  name: 'TkNestedRadio',
  components: {
    TkLink,
    TkRadio,
  },
  props: {
    root: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      path: [],
      selected: '',
    }
  },
  computed: {
    currentItem() {
      let currentItem = this.root
      if (this.path.length) {
        currentItem = this.path.reduce(({ items = [] }, selected) => {
          if (!items.length) {
            return {}
          }
          return items.find(({ value }) => value === selected)
        }, this.root)
      }

      const selectable = currentItem.items.some(
        ({ items }) => !items || !items.length
      )
      this.$emit('selectable', selectable)
      return currentItem
    },
  },
  watch: {
    selected(selected) {
      const items = this.currentItem.items || []
      const selectedItem = items.find(({ value }) => value === selected)
      const isLeafItem =
        selectedItem && !(selectedItem.items && !!selectedItem.items.length)

      isLeafItem && this.$emit('selected', selectedItem)
    },
  },
  methods: {
    onBack() {
      this.selected = this.path.pop()
    },
    onClicked({ items = [] }) {
      if (!items.length) {
        return
      }

      this.path.push(this.selected)
      this.selected = null
    },
  },
}
</script>
